import { createFileRoute } from "@tanstack/react-router";

import TenantDetailPage from "@/features/dashboard/pages/tenant-detail";

function OpsTenantDetail() {
  const { tenantPublicId } = Route.useParams();
  return <TenantDetailPage tenantPublicId={tenantPublicId} />;
}

export const Route = createFileRoute("/(app)/ops/organisations/$tenantPublicId")({
  component: OpsTenantDetail,
});
